import { liveValidatePattern } from '../validate/pattern';
import { liveValidateMaxLength } from '../validate/maxlength';
import { liveValidateMinLength } from '../validate/minlength';
import { liveValidateRequired } from '../validate/required';
import { liveValidateBlur } from '../validate/blur';
import { liveValidateSubmit, validateSubmit, autoFocusFirstOnSubmitError } from '../validate/submit';
import { setLoadingIndicator } from '../forms/loading-indicator';

export default function validateHelprequestForm(element: string) {
    const form: HTMLFormElement | null = document.querySelector(element);
    if (form) {
        form.setAttribute('novalidate', 'novalidate');
        const inputs = [form.screenname, form.emailaddress, form.departmentid, form.subject, form.message, form.requestID].filter((item: HTMLInputElement) => {
            return item;
        });

        for (const el of inputs) {
            liveValidateMinLength(el);
            liveValidateMaxLength(el);
            liveValidatePattern(el);
            liveValidateBlur(el);
            liveValidateRequired(el);
        }
        liveValidateSubmit(form);
        form.addEventListener('submit', function (this: HTMLFormElement, e: Event) {
            const errors = validateSubmit(inputs);
            const valid = errors.indexOf(false) === -1;
            if (!valid) {
                form.classList.add('focus-visible');
                autoFocusFirstOnSubmitError(this);
                e.preventDefault();
                return false;
            }

            setLoadingIndicator(this);

            return;
        });
    }
}
